const Header = () => {
  return (
    <header>
      <div className="nametag">Lauren Wilson</div>
    </header>
  );
};

export default Header;
